import { useState } from "react";
import FooterDocs from "../components/FooterDocs";


export default function Documentacion() {
    const [seccionActiva, setSeccionActiva] = useState("introduccion");

  const secciones = [
    { id: "introduccion", titulo: "Introducción" },
    { id: "instalacion", titulo: "Instalación" },
    { id: "uso", titulo: "Ejemplos de Uso" },
    { id: "api", titulo: "Referencia API" },
    { id: "licencia", titulo: "Licencia" },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900 pt-16">
        <div className="flex flex-1">
            {/* Sidebar */}
            <aside className="w-64 bg-gray-100 dark:bg-gray-800 p-4">
                <h2 className="text-xl font-bold mb-6">Documentación</h2>
                <nav className="space-y-2">
                {secciones.map((sec) => (
                    <button
                    key={sec.id}
                    onClick={() => setSeccionActiva(sec.id)}
                    className={`block w-full text-left px-3 py-2 rounded-lg ${
                        seccionActiva === sec.id
                        ? "bg-blue-600 text-white"
                        : "text-gray-700 hover:bg-gray-100"
                    }`}
                    >
                    {sec.titulo}
                    </button>
                ))}
                </nav>
            </aside>

            {/* Contenido */}
            <main className="flex-1 p-8">
                <h1 id="introduccion" className="text-3xl font-bold mb-4">📌 Identidad Ecuador (Identidad-EC)</h1>
                {seccionActiva === "introduccion" && (
                    <section>
                    <h1 className="text-3xl font-bold mb-4">Introducción</h1>
                    <p className="text-gray-700 leading-relaxed">
                    <strong>identidad-ec</strong> es una librería para validar
                    cédulas y RUCs del Ecuador en distintos lenguajes
                    (Python, TypeScript, PHP).
                    Su objetivo es simplificar la verificación de
                    identificaciones oficiales con reglas actualizadas.
                    </p>
                </section>
                )}

                {seccionActiva === "instalacion" && (
                <section>
                    <h1 className="text-3xl font-bold mb-4">Instalación</h1>
                    <p className="text-gray-700 mb-4">
                    Según el lenguaje que estés usando:
                    </p>
                    <div className="space-y-4">
                    <div>
                        <h3 className="font-semibold">📦 Python</h3>
                        <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto">
                        pip install identidad-ec
                        </pre>
                    </div>
                    <div>
                        <h3 className="font-semibold">⚡ TypeScript / JavaScript</h3>
                        <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto">
                        npm install identidad-ec
                        </pre>
                    </div>
                    <div>
                        <h3 className="font-semibold">🐘 PHP</h3>
                        <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto">
                        composer require identidad-ec/identidad-ec
                        </pre>
                    </div>
                    </div>
                </section>
                )}

                {seccionActiva === "uso" && (
                <section>
                    <h1 className="text-3xl font-bold mb-4">Ejemplos de Uso</h1>

                    <h3 className="mt-6 font-semibold">🔹 Python</h3>
                    <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto">
        {`from identidad_ec import validar_identificacion

        print(validar_identificacion("1710034065"))
        # {'valido': True, 'tipo': 'Cédula', 'mensaje': 'Cédula válida'}`}
                    </pre>

                    <h3 className="mt-6 font-semibold">🔹 TypeScript</h3>
                    <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto">
        {`import { validarIdentificacion } from "identidad-ec";

        console.log(validarIdentificacion("1710034065"));
        // { valido: true, tipo: "Cédula", mensaje: "Cédula válida" }`}
                    </pre>

                    <h3 className="mt-6 font-semibold">🔹 PHP</h3>
                    <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto">
        {`use IdentidadEc\\Identificacion;

        $resultado = Identificacion::validar("1710034065");
        print_r($resultado);`}
                    </pre>
                </section>
                )}

                {seccionActiva === "api" && (
                <section>
                    <h1 className="text-3xl font-bold mb-4">Referencia API</h1>
                    <ul className="list-disc pl-6 text-gray-700 space-y-2">
                    <li>
                        <code>validar_identificacion(numero)</code> → Retorna
                        objeto con {`{valido, tipo, mensaje}`}.
                    </li>
                    <li>
                        Soporta cédulas y RUCs (naturales, jurídicos y públicos).
                    </li>
                    <li>
                        Verificación basada en reglas del Registro Civil y SRI.
                    </li>
                    </ul>
                </section>
                )}

                {seccionActiva === "licencia" && (
                <section>
                    <h1 className="text-3xl font-bold mb-4">Licencia</h1>
                    <p className="text-gray-700">
                    Este proyecto está bajo la licencia MIT. Puedes usarlo libremente
                    en proyectos personales y comerciales.
                    </p>
                </section>
                )}

            </main>
        </div>

    <FooterDocs />
    </div>
  );
}
